import {Component, inject, input, OnInit, signal} from "@angular/core";
import {SimConfigurationService, SimLmsService} from "@services";
import {EventEmitterService} from "@event-emitter";
import {LmsEntityStatus} from "@models";
import {Translations} from "@translations";

@Component({
	selector: "sim-lms-publish-control",
	templateUrl: "./lms-publish-control.component.html",
	styleUrl: "./lms-publish-control.component.scss",
	standalone: false,
	providers: [EventEmitterService],
})
export class LmsPublishControlComponent implements OnInit {
	protected readonly T = Translations;
	private readonly settings = SimConfigurationService.settings;
	private readonly eventEmitterService = inject(EventEmitterService);
	private readonly lmsService = inject(SimLmsService);

	public entityId = input.required<string>();
	public status = signal<LmsEntityStatus | null>(null);
	public isLoading = signal<boolean>(false);

	public constructor() {
		this.eventEmitterService.onLmsEntityStatusChanged.subscribe((data) => {
			if (data.status.id == this.entityId()) {
				this.isLoading.set(false);
				this.status.set(data.status);
			}
		});
	}

	public async ngOnInit() {
		if (this.settings.lmsIntegrationEnabled) {
			const status = await this.lmsService.getStatus(this.entityId());
			this.status.set(status);
		}
	}

	public async upload() {
		if (this.isLoading()) return;
		if (this.settings.lmsIntegrationEnabled) {
			this.isLoading.set(true);
			await this.lmsService.uploadEntity(this.entityId());
			this.isLoading.set(false);
		}
	}

	public async publish() {
		if (this.isLoading()) return;
		if (this.settings.lmsIntegrationEnabled) {
			this.isLoading.set(true);
			await this.lmsService.publishEntity(this.entityId(), !this.status()?.isPublished);
			this.isLoading.set(false);
		}
	}
}
